import api from '@/lib/api';
import type { CandidateJob } from '../types';

export interface JobSearchResult {
  id: number;
  name: string;
  subActivityId: number;
  subActivityName: string;
  activityName: string;
  nameNormalized: string | null;
  description: string | null;
  aliases: string[];
  typicalSkills: string[];
  isActive: boolean;
}

/**
 * Service pour les associations candidat ↔ jobs et la recherche de nomenclature
 */
export const candidateJobsService = {
  /**
   * Liste les jobs associés à un candidat
   */
  async getCandidateJobs(candidateId: number): Promise<CandidateJob[]> {
    const { data } = await api.get<CandidateJob[]>(`/itc/candidates/${candidateId}/jobs`);
    return data;
  },

  /**
   * Assigne des jobs à un candidat
   */
  async assignJobs(candidateId: number, jobIds: number[], source: string = 'manual'): Promise<{ assigned: number }> {
    const { data } = await api.post<{ assigned: number }>(`/itc/candidates/${candidateId}/jobs`, {
      jobIds,
      source,
    });
    return data;
  },

  /**
   * Retire un job d'un candidat
   */
  async removeJob(candidateId: number, jobId: number): Promise<void> {
    await api.delete(`/itc/candidates/${candidateId}/jobs/${jobId}`);
  },

  /**
   * Définit un job comme métier principal
   */
  async setPrimaryJob(candidateId: number, jobId: number): Promise<void> {
    await api.patch(`/itc/candidates/${candidateId}/jobs/${jobId}/primary`, { isPrimary: true });
  },

  /**
   * Recherche des jobs dans la nomenclature (fuzzy search)
   */
  async searchJobs(query: string, limit: number = 20): Promise<JobSearchResult[]> {
    const params = new URLSearchParams({ query, limit: String(limit) });
    const { data } = await api.get<JobSearchResult[]>(`/itc/nomenclature/jobs/search?${params}`);
    return data;
  },
};
